<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>统一资源录入</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>学生资源录入</span>
        </div>
        <el-form :model="form" ref="form" label-width="120px" :status-icon="true"
          @submit.native.prevent="submitForm('form')">
          <!-- 资源类型选择 -->
          <el-form-item label="资源类型" prop="resourceTypes" :rules="[
            { 
              validator: (rule, value, callback) => {
                if (this.resourceTypes.length === 0) {
                  callback(new Error('请至少选择一种资源类型'));
                } else {
                  callback();
                }
              }, 
              trigger: 'change' 
            }
          ]">
            <el-checkbox-group v-model="resourceTypes" @change="onResourceTypeChange">
              <el-checkbox label="留学">留学资源</el-checkbox>
              <el-checkbox label="日语">日语资源</el-checkbox>
              <el-checkbox label="鸣野">鸣野资源</el-checkbox>
            </el-checkbox-group>
            <div style="color: #909399; font-size: 12px; margin-top: 5px;">
              提示：可以同时选择多种资源类型，学生信息将在对应的部门列表中显示
            </div>
          </el-form-item>

          <el-divider content-position="left">基础信息</el-divider>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="添加时间" prop="inputTime" :rules="[{ required: true, message: '请填写日期' }]">
                <el-date-picker v-model="form.inputTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                  placeholder="选择时间" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="姓名" prop="realName" :rules="[{ required: true, message: '请输入姓名' }]">
                <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="性别" prop="sex" :rules="[{ required: true, message: '请选择性别' }]">
                <el-radio-group v-model="form.sex">
                  <el-radio :label="true">男</el-radio>
                  <el-radio :label="false">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="跟进状态" prop="state" :rules="[{ required: true, message: '请选择跟进状态' }]">
                <el-select v-model="form.state" placeholder="请选择跟进状态" filterable style="width: 100%">
                  <el-option v-for="item in statelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
                <div v-if="resourceTypes.length > 0" style="color: #909399; font-size: 12px; margin-top: 2px;">
                  将应用于已选资源类型（留学/日语/鸣野）
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="来源" prop="origin">
                <el-select v-model="form.origin" placeholder="请选择来源" clearable filterable @change="changeReouce" style="width: 100%">
                  <el-option v-for="item in sourselist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="form.state == 'e'">
            <el-col :span="10">
              <el-form-item label="淘汰原因" prop="reason" :rules="[{ required: true, message: '请选择淘汰原因' }]">
                <el-select v-model="form.reason" placeholder="请选择淘汰原因" filterable style="width: 100%">
                  <el-option v-for="item in reasonlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="来源备注" prop="originRemark" v-if="form.origin == '线下市场' || form.origin == '其他'">
            <el-input v-model="form.originRemark" placeholder="请输入来源备注"></el-input>
          </el-form-item>

          <el-form-item label="推荐人" prop="recName" v-if="form.origin == '留学组推荐' || form.origin == '日语组推荐'">
            <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
              <el-option v-for="item in adviserList" :label="item.realName" :value="item.realName"
                :key="item.userID"></el-option>
            </el-select>
          </el-form-item>

          <!-- 来源有次级选项时显示：抖音=直播/短视频，小红书=账号来源（留学官号、小花学姐等），数据来自 GetStuParam 的 originParam[].children -->
          <el-form-item :label="form.origin == '小红书' ? '小红书' : labelorgin" prop="recName" v-if="ischildren || (form.origin == '小红书' && subOriginOptions.length > 0)">
            <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
              <el-option v-for="item in subOriginOptions" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="合作方推荐" prop="recName" v-if="form.origin == '合作方推荐'">
            <el-select v-model="form.recName" placeholder="请选择" filterable clearable style="width: 100%">
              <el-option v-for="item in partlist" :label="item.title" :value="item.title" :key="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="学历" prop="eduBack" :rules="[{ required: true, message: '请选择学历' }]">
                <el-select v-model="form.eduBack" placeholder="请选择学历" filterable @change="eduBackChange" style="width: 100%">
                  <el-option v-for="item in edubacklist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="计划赴日" prop="abroadPlan" v-if="resourceTypes.includes('留学')">
                <el-select v-model="form.abroadPlan" placeholder="请选择时间" filterable style="width: 100%">
                  <el-option v-for="item in planList" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 学历相关字段：专业或文理 -->
          <el-row :gutter="20" v-if="showMajorInput">
            <el-col :span="10">
              <el-form-item label="专业" prop="major">
                <el-input v-model="form.major" placeholder="请输入专业（选填）"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="showArtsScienceSelect">
            <el-col :span="10">
              <el-form-item label="文理" prop="artsScience">
                <el-select v-model="form.artsScience" placeholder="请选择文理（选填）" filterable clearable style="width: 100%">
                  <el-option label="文科" value="文科"></el-option>
                  <el-option label="理科" value="理科"></el-option>
                  <el-option label="艺术" value="艺术"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="微信" prop="wechat">
                <el-input v-model="form.wechat" placeholder="请输入微信号" @input="wechatInputDebounce" @blur="wechatChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="电话" prop="mobile">
                <el-input v-model.number="form.mobile" type="number" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-alert type="warning" style="position: relative; top: -10px" v-if="form.wechatCheck">{{ form.wechatCheck }}</el-alert>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="年龄" prop="age">
                <el-input v-model.number="form.age" type="number" placeholder="请输入年龄"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="学生/家长" prop="jpStudentType">
                <el-select v-model="form.jpStudentType" placeholder="请选择" filterable clearable style="width: 100%">
                  <el-option label="学生" value="学生"></el-option>
                  <el-option label="家长" value="家长"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="现住地址">
            <el-cascader :options="areaList" :props="{ label: 'label', value: 'label' }" v-model="selectedOptions"
              style="width: 100%" clearable></el-cascader>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="日语" prop="japaneseBase">
                <el-select v-model="form.japaneseBase" placeholder="请选择日语等级" filterable style="width: 100%">
                  <el-option v-for="item in japlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="英语" prop="english">
                <el-input v-model="form.english" placeholder="请输入英语水平"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="目前状况" prop="followSummary">
            <el-input v-model="form.followSummary" type="textarea" :rows="3" placeholder="请输入目前跟进状况"></el-input>
          </el-form-item>

          <!-- 留学资源相关字段 -->
          <template v-if="resourceTypes.includes('留学')">
            <el-divider content-position="left">留学资源信息</el-divider>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="留学顾问" prop="adviserID" >
                  <el-select v-model="form.adviserID" placeholder="请选择留学顾问" filterable style="width: 100%">
                    <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID"
                      :key="item.userID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="留学营销" prop="marketID">
                  <DeptRoleTeacherSelect v-model="form.marketID" dept="留学" placeholder="请选择部门 → 角色 → 老师" />
                </el-form-item>
              </el-col>
      
              <el-col :span="10">
                <el-form-item label="文案老师" prop="documentID" >
                  <el-select v-model="form.documentID" placeholder="请选择" filterable clearable style="width: 100%">
                    <el-option v-for="item in documentList" :label="item.realName" :value="item.userID"
                      :key="item.userID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
          
              <el-col :span="10">
                <el-form-item label="留学目的" prop="purpose">
                  <el-select v-model="form.purpose" placeholder="请选择留学目的" filterable clearable style="width: 100%">
                    <el-option label="升学" value="升学"></el-option>
                    <el-option label="就职" value="就职"></el-option>
                    <el-option label="专门学校" value="专门学校"></el-option>
                    <el-option label="体验" value="体验"></el-option>
                    <el-option label="未定" value="未定"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <!-- 日语资源相关字段 -->
          <template v-if="resourceTypes.includes('日语')">
            <el-divider content-position="left">日语资源信息</el-divider>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="日语顾问" prop="jpAdviserID">
                  <el-select v-model="form.jpAdviserID" placeholder="请选择日语顾问" filterable clearable style="width: 100%">
                    <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID"
                      :key="item.userID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="日语营销" prop="jpMarketID">
                  <DeptRoleTeacherSelect v-model="form.jpMarketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="意向形式" prop="jpIntendedForm">
                  <el-select v-model="form.jpIntendedForm" placeholder="请选择" filterable clearable style="width: 100%">
                    <el-option label="网课" value="网课"></el-option>
                    <el-option label="线下课" value="线下课"></el-option>
                    <el-option label="录播课" value="录播课"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="学习目的" prop="jpLearningPurpose">
                  <el-select v-model="form.jpLearningPurpose" placeholder="请选择" filterable clearable style="width: 100%">
                    <el-option label="留学" value="留学"></el-option>
                    <el-option label="赴日工作" value="赴日工作"></el-option>
                    <el-option label="在日升学" value="在日升学"></el-option>
                    <el-option label="兴趣" value="兴趣"></el-option>
                    <el-option label="工作" value="工作"></el-option>
                    <el-option label="高考日语" value="高考日语"></el-option>
                    <el-option label="考研日语" value="考研日语"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <!-- 鸣野资源相关字段 -->
          <template v-if="resourceTypes.includes('鸣野')">
            <el-divider content-position="left">
              <span>鸣野资源信息</span>
              <!-- 2026-01升级：如果同时选择了留学资源，显示同步按钮 -->
              <el-button 
                v-if="resourceTypes.includes('留学')" 
                type="text" 
                size="small" 
                icon="el-icon-refresh"
                @click="syncStudentInfoToMingye"
                style="margin-left: 10px; color: #409EFF;">
                同步留学信息
              </el-button>
            </el-divider>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="鸣野顾问" prop="myAdviserID">
                  <el-select v-model="form.myAdviserID" placeholder="请选择鸣野顾问" filterable clearable style="width: 100%">
                    <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID"
                      :key="item.userID"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="鸣野营销" prop="myMarketID">
                  <DeptRoleTeacherSelect v-model="form.myMarketID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="升学阶段" prop="stage">
                  <el-radio-group v-model="form.stage">
                    <el-radio :label="1">赴日前</el-radio>
                    <el-radio :label="2">升学时</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="日语" prop="japanese">
                  <el-select v-model="form.japanese" placeholder="请选择日语水平" filterable clearable style="width: 100%">
                    <el-option v-for="item in mingyeJaplist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="英语" prop="english">
                  <el-input v-model="form.english" placeholder="请输入英语水平"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </template>

          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="goBack">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import { prepareUnifiedSubmitTime } from "@/plugins/japFormHelper.js";
import DeptRoleTeacherSelect from '@/components/DeptRoleTeacherSelect.vue';

export default {
  name: 'NewStudent',
  components: { DeptRoleTeacherSelect },
  data() {
    var now = new Date();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    var today = now.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (d < 10 ? "0" : "") + d;
    
    return {
      userIsAdmain: user.isAdmin(), //是否是管理员
      userIsMarket: user.isMarket(), //是否是营销
      userIsAdviser: user.isAdviser(), //是否是顾问
      resourceTypes: ['留学'], //资源类型选择：['留学', '日语', '鸣野']，默认为留学
      form: {
        sex: true,
        inputTime: today,
        isAbove: true,
        isStudent: false,
        isJap: false,
        isMingye: false,
        stage: 1, // 鸣野升学阶段：1=赴日前，2=升学时
        japanese: '', // 鸣野日语水平（下拉）
        major: '', // 专业
        artsScience: '', // 文理
        purpose: '', // 留学目的
        wechatCheck: '', // 微信重复检测提示
      },
      showMajorInput: false, // 显示专业输入框
      showArtsScienceSelect: false, // 显示文理选择
      submiting: false,
      wechatCheckTimer: null, // 微信查重防抖定时器
      areaList: [],
      selectedOptions: [],
      adviserList: [],   // 推荐人用（留学组推荐/日语组推荐）
      allAdviserList: [], // 所有顾问（留学+日语+鸣野），三个顾问下拉共用
      marketStuList: [],    // 留学营销（4,10）
      marketJapList: [],    // 日语营销（13）
      marketMingyeList: [],  // 鸣野营销（17）
      documentList: [],
      planList: url.getAbroadYear(), //计划赴日时间
      sourselist: [], //来源
      edubacklist: url.getEduBack(), //学历
      japlist: url.getJapLevelListForStu(), // 日语水平（留学/日语资源，统一数据）
      mingyeJaplist: url.getJapLevelList(), // 鸣野日语水平（与日语资源/Stu_Mingye 统一）
      enlist: [
        { id: "好", name: "好" },
        { id: "一般", name: "一般" },
        { id: "差", name: "差" },
        { id: "有托福托业成绩", name: "有托福托业成绩" },
      ], //英语水平
      statelist: url.getStateData(), //跟进状态
      reasonlist: [
        { id: "不回复", name: "不回复" },
        { id: "资金问题", name: "资金问题" },
        { id: "家长不同意", name: "家长不同意" },
        { id: "找其他中介", name: "找其他中介" },
        { id: "非本地中介", name: "非本地中介" },
        { id: "心理健康", name: "心理健康" },
        { id: "生理健康", name: "生理健康" },
        { id: "其他原因", name: "其他原因" },
      ], //淘汰原因
      tiktoklist: [
        { id: 1, name: "直播" },
        { id: 2, name: "短视频" },
      ], //抖音推荐（已改用 subOriginOptions 从接口 originParam.children 获取）
      partlist: [], //合作方推荐
      ischildren: false,
      labelorgin: '',
      subOriginOptions: [], // 当前来源的次级选项，来自 GetStuParam 的 originParam[].children（如抖音的直播/短视频、小红书的账号来源等）
      id:0,
    };
  },
  mounted() {
    // 接收参数（编辑时传入 id，确保为数字）
    this.id = parseInt(this.$route.query.id, 10) || 0;
    this.initData();
  },
  methods: {
    
    //初始化数据
    initData() {
      this.getAllOrigin();
      this.getAdviser();
      this.getUsersByRole();
      this.getDocument();
      this.getArea();
      this.getAllPart();
      if (this.id > 0) {
        this.form.id = this.id; // 编辑进入时先写入 id，避免 GetStudentModel 未返回就保存时提交无 id 而误走新增产生重复
        this.GetStudentModel();
      }
    },
    // 获取来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
        // 编辑时若学生数据已加载，再根据来源刷新来源备注/推荐人显示
        if (_this.id > 0 && _this.form && _this.form.origin) {
          _this.changeReouce(_this.form.origin);
        }
      });
    },
    // 获取合作方
    getAllPart() {
      var _this = this;
      var link = url.getStu("GetAllPartner");
      $.get(link, {}, (data) => {
        _this.partlist = data;
      });
    },
    //获取地区数据
    getArea() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, (data) => {
        _this.areaList = data;
      });
    },
    //获取顾问老师
    getAdviser() {
      var _this = this;
      var link = url.getStu("GetAdviser");
      $.get(link, {}, (data) => {
        _this.adviserList = data;
      });
    },
    //获取文案老师
    getDocument() {
      var _this = this;
      var link = url.getStu("GetDocument");
      $.get(link, {}, (data) => {
        _this.documentList = data;
      });
    },
    // 按角色获取人员（顾问统一显示所有组，营销仍按部门）
    getUsersByRole() {
      var _this = this;
      var link = url.getStu("GetUsersByRole");
      // 所有顾问（3,9 留学 + 11,16 日语 + 15,19 鸣野），三个顾问下拉共用
      $.get(link, { roleIds: '3,9,11,16,15,19' }, (data) => {
        _this.allAdviserList = data || [];
      });
      // 留学营销（4,10）
      $.get(link, { roleIds: '4,10' }, (data) => {
        _this.marketStuList = data || [];
      });
      // 日语营销（13,18）
      $.get(link, { roleIds: '13,18' }, (data) => {
        _this.marketJapList = data || [];
      });
      // 鸣野营销（17,20）
      $.get(link, { roleIds: '17,20' }, (data) => {
        _this.marketMingyeList = data || [];
      });
    },
    //来源变化：若当前来源在 originParam 中配置了 children（如抖音的直播/短视频、小红书的账号来源），则显示次级下拉，选项从接口数据获取
    changeReouce(val) {
      var origin = this.form.origin;
      this.labelorgin = origin;

      const index = this.sourselist.findIndex(item => item.id == val);
      if (index >= 0 && this.sourselist[index].children && this.sourselist[index].children.length > 0) {
        this.ischildren = true;
        this.subOriginOptions = this.sourselist[index].children;
      } else {
        this.ischildren = false;
        this.subOriginOptions = [];
      }
    },
    //学历变化
    eduBackChange(val) {
      // 大专或本科学历，显示专业输入框
      if (val === '大专' || val === '本科') {
        this.showMajorInput = true;
        this.showArtsScienceSelect = false;
        this.form.artsScience = ''; // 清空文理选择
      }
      // 高中学历，显示文理选择
      else if (val === '高中') {
        this.showMajorInput = false;
        this.showArtsScienceSelect = true;
        this.form.major = ''; // 清空专业
      }
      // 其他学历，隐藏两个字段
      else {
        this.showMajorInput = false;
        this.showArtsScienceSelect = false;
        this.form.major = '';
        this.form.artsScience = '';
      }
    },
    // 资源类型变化时重新检测（等待数据更新后再检测）
    onResourceTypeChange() {
      this.$nextTick(() => {
        this.wechatChange();
      });
    },
    // 微信输入防抖（输入时实时检测，300ms防抖）
    wechatInputDebounce() {
      if (this.wechatCheckTimer) clearTimeout(this.wechatCheckTimer);
      this.wechatCheckTimer = setTimeout(() => {
        this.wechatChange();
      }, 300);
    },
    // 同板块微信查重（仅选中板块内查重）
    wechatChange() {
      var _this = this;
      if (!this.form.wechat) {
        this.form.wechatCheck = '';
        return;
      }
      var isStudent = this.resourceTypes.includes('留学');
      var isJap = this.resourceTypes.includes('日语');
      var isMingye = this.resourceTypes.includes('鸣野');
      if (!isStudent && !isJap && !isMingye) {
        this.form.wechatCheck = '';
        return;
      }
      $.get(url.getStu("CheckWechatDuplicate"), {
        wechat: this.form.wechat,
        isStudent: isStudent,
        isJap: isJap,
        isMingye: isMingye,
        excludeId: this.form.id || 0
      }, (data) => {
        if (data.hasDuplicate && data.items && data.items.length > 0) {
          var msg = '资源重复！';
          data.items.forEach(function(it) {
            msg += ' 【' + it.blockName + '】跟进顾问：' + (it.adviserName || '-') + '，营销：' + (it.marketName || '-') + '，录入时间：' + (it.inputTime || '-');
          });
          _this.form.wechatCheck = msg;
        } else {
          _this.form.wechatCheck = '';
        }
      });
    },
    // 2026-01升级：同步留学信息到鸣野
    syncStudentInfoToMingye() {
      // 将留学资源的信息同步到鸣野资源
      // 同步顾问：如果留学顾问有值，且鸣野顾问为空，则同步
      if (this.form.adviserID && !this.form.myAdviserID) {
        this.form.myAdviserID = this.form.adviserID;
      }
      // 同步营销：如果留学营销有值，且鸣野营销为空，则同步
      if (this.form.marketID && !this.form.myMarketID) {
        this.form.myMarketID = this.form.marketID;
      }
      
      this.$message({
        type: 'success',
        message: '已同步留学信息到鸣野'
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      
      // 验证资源类型
      if (this.resourceTypes.length === 0) {
        this.$message({
          type: "error",
          message: "请至少选择一种资源类型"
        });
        return;
      }

      // 资源类型仅以勾选为准：只有勾选「留学」才是留学资源，与是否填留学顾问/营销无关
      this.form.isStudent = this.resourceTypes.includes('留学');
      this.form.isJap = this.resourceTypes.includes('日语');
      this.form.isMingye = this.resourceTypes.includes('鸣野');

      var link = url.getStu("addorupdate_unified");
      var info = Object.assign({}, this.form);
      // 编辑时务必带上 id，避免未回填就保存或 form.id 丢失时误走新增导致重复资源（从资源管理列表编辑后出现多条相同记录）
      if (this.id > 0) {
        info.id = this.id;
      }
      // 提交前再次按当前勾选写入，确保后端收到的 isStudent/isJap/isMingye 与界面一致
      info.isStudent = !!this.resourceTypes.includes('留学');
      info.isJap = !!this.resourceTypes.includes('日语');
      info.isMingye = !!this.resourceTypes.includes('鸣野');
      // 统一资源录入：所选「跟进状态」同步到已勾选部门的对应字段，避免仅留学有值、日语/鸣野靠后端默认
      var stateVal = (this.form.state !== undefined && this.form.state !== null) ? String(this.form.state).trim() : '';
      if (info.isStudent) info.State = stateVal;
      else {
        delete info.state;
        delete info.State;
      }
      if (info.isJap) info.JpStatus = stateVal;
      else {
        delete info.jpStatus;
        delete info.JpStatus;
      }
      if (info.isMingye) info.MyStatus = stateVal;
      else {
        delete info.myStatus;
        delete info.MyStatus;
      }
      prepareUnifiedSubmitTime(info);

      // 处理地址
      if (this.selectedOptions && this.selectedOptions.length > 0) {
        info.zzProvinceName = this.selectedOptions[0];
        info.zzCityName = this.selectedOptions[1];
      } else {
        info.zzProvinceName = "";
        info.zzCityName = "";
      }

      // 学生/家长在基础信息中，提交时同步到日语和鸣野
      if (this.form.isJap) info.jpStudentType = this.form.jpStudentType;
      if (this.form.isMingye) info.myStudentType = this.form.jpStudentType;

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
                onClose() {
                  _this.goBack();
                }
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //重置表单
    resetForm() {
      var now = new Date();
      var today = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      this.resourceTypes = ['留学']; // 重置时默认选择留学
      this.form = {
        sex: true,
        inputTime: today,
        isAbove: true,
        isStudent: false,
        isJap: false,
        isMingye: false,
        stage: 1,
        japanese: '',
        major: '',
        artsScience: '',
        purpose: '',
        jpLearningPurpose: '',
        jpIntendedForm: '',
      };
      this.selectedOptions = [];
      this.showMajorInput = false;
      this.showArtsScienceSelect = false;
      this.$refs.form.clearValidate();
    },
    //返回：从统一资源列表进入则返回该列表，否则返回留学列表
    goBack() {
      const from = this.$route.query.from;
      if (from === 'studentlist') {
        this.$router.push({ name: 'studentlist' });
      } else {
        this.$router.push({ name: 'common' });
      }
    },
    // 兼容后端 camelCase / PascalCase 的取值
    _fromApi(d, key, def) {
      const v = d[key];
      const p = d[key.charAt(0).toUpperCase() + key.slice(1)];
      const val = v !== undefined && v !== null ? v : (p !== undefined && p !== null ? p : def);
      return ['isStudent', 'isJap', 'isMingye'].includes(key) ? !!val : val;
    },
    // 获取学生（编辑时回填表单）
    GetStudentModel() {
      const _this = this;
      const id = this.id;
      $.get(url.getStu("GetStudentModel"), { id }, (data) => {
        const d = data || {};
        const keys = ['id', 'realName', 'inputTime', 'sex', 'state', 'origin', 'wechat', 'mobile', 'age', 'eduBack', 'major', 'artsScience', 'abroadPlan', 'followSummary', 'japaneseBase', 'english', 'purpose', 'reason', 'recName', 'originRemark', 'zzProvinceName', 'zzCityName', 'marketID', 'adviserID', 'documentID', 'isStudent', 'isJap', 'isMingye', 'jpAdviserID', 'jpMarketID', 'myAdviserID', 'myMarketID', 'jpStudentType', 'stage', 'japanese', 'jpStatus', 'myStatus', 'jpLearningPurpose', 'jpIntendedForm'];
        const defaults = { stage: 1 };
        const patch = {};
        keys.forEach(k => { patch[k] = _this._fromApi(d, k, defaults[k]); });
        _this.form = Object.assign({}, _this.form, patch);
        // 编辑回填：跟进状态按资源类型取对应字段（留学=State，日语=JpStatus，鸣野=MyStatus），保证下拉显示正确
        var stateFromApi = _this._fromApi(d, 'state', '') || _this._fromApi(d, 'jpStatus', '') || _this._fromApi(d, 'myStatus', '');
        if (stateFromApi !== undefined && stateFromApi !== null && stateFromApi !== '') _this.form.state = stateFromApi;
        if (typeof _this.form.inputTime === 'string' && _this.form.inputTime.length > 10) {
          _this.form.inputTime = _this.form.inputTime.substring(0, 10);
        }
        // 日语资源编辑时优先显示日语板块添加时间
        var jpIt = _this._fromApi(d, 'jpInputTime', '');
        if (_this.form.isJap && jpIt) {
          _this.form.inputTime = String(jpIt).substring(0, 10);
        }
        _this.resourceTypes = [_this.form.isStudent && '留学', _this.form.isJap && '日语', _this.form.isMingye && '鸣野'].filter(Boolean);
        if (!_this.resourceTypes.length) _this.resourceTypes = ['留学'];
        _this.selectedOptions = [_this.form.zzProvinceName, _this.form.zzCityName].filter(Boolean);
        _this.eduBackChange(_this.form.eduBack);
        _this.changeReouce(_this.form.origin);
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin-top: 20px;
}
</style>

